<template>
  <el-form
    ref="forms"
    :model="sizeForm"
    :rules="baseRule"
    label-width="120px"
    class="signForm"
    size="mini"
  >
    <el-form-item label="合同名称：" class="nameContract" prop="name">
      <el-input v-model="sizeForm.name"></el-input>
    </el-form-item>
    <el-form-item
      label="合同有效期："
      prop="dateRange"
      class="datePickerStyle"
      style="display: inline-block"
    >
      <el-radio-group v-model="dateType" @change="dateTypeChange">
        <el-radio label="1">手动选择起止时间</el-radio>
        <el-radio label="2" disabled>选择固定有效期限</el-radio>
      </el-radio-group>
      <div class="chooseWay">
        <div v-if="dateType == 1">
          <el-date-picker
            v-model="sizeForm.dateRange"
            type="date"
            :picker-options="signDeadlineDateOption"
            :editable="false"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期"
            disabled
          ></el-date-picker>
          <span class="ft12" style="color: #969696"
            >&nbsp;&nbsp;至&nbsp;&nbsp;</span
          >
        </div>
        <div v-if="dateType == 2" class="validityBox">
          有效期
          <el-input v-model="sizeForm.dateRange"></el-input>
          <div class="timeTypeBox">
            <el-select v-model="unitForTime" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <span>合同自各方均加盖电子签章之日起生效</span>
        </div>
      </div>
    </el-form-item>
    <el-form-item
      prop="endDate"
      label-width="0"
      style="display: inline-block; margin-left: -84px"
      class="datePickerStyle"
      v-if="dateType == 1"
    >
      <!-- <customer-date-picker
        @click.native="isHaveStartData"
        v-model="sizeForm.endDate"
        @disabledCallBack="clickDisabledFunForEndData"
        type="date"
        :picker-options="getSinDataForEndDate"
        :editable="false"
        @change="validStart"
        :disabled="!sizeForm.dateRange"
        value-format="yyyy-MM-dd"
        placeholder="选择结束日期"
      ></customer-date-picker> -->
      <customer-date-picker
        v-model="sizeForm.endDate"
        @disabledCallBack="clickDisabledFunForEndData"
        type="date"
        :picker-options="getSinDataForEndDate"
        :editable="false"
        @change="validStart"
        disabled
        value-format="yyyy-MM-dd"
        placeholder="选择结束日期"
      ></customer-date-picker>
      <!-- <span class="formItemDscp">合同到期前，系统将提醒您</span> -->
    </el-form-item>
    <el-form-item label="签约截止日期：" prop="signDeadlineDate">
      <!-- <customer-date-picker
        @click.native="isHaveStartData"
        v-model="sizeForm.signDeadlineDate"
        @disabledCallBack="clickDisabledFun"
        :disabled="!sizeForm.dateRange&&dateType==1"
        type="date"
        placeholder="选择日期"
        :editable="false"
        :value-format="'yyyy-MM-dd'"
        :picker-options="getSinDataForDealLine"
      ></customer-date-picker> -->
      <customer-date-picker
        v-model="sizeForm.signDeadlineDate"
        disabled
        type="date"
        placeholder="选择日期"
        :editable="false"
        :value-format="'yyyy-MM-dd'"
        :picker-options="getSinDataForDealLine"
      ></customer-date-picker>
      <!-- <span class="formItemDscp">所有签署方需在截止日期前完成签署</span> -->
    </el-form-item>
    <el-form-item label="付费方式：">
      <!-- 选择付费方式 -->
      <el-radio-group v-model="paymentType" @change="paymentTypeChange">
        <!-- <el-radio label="1" :disabled="curDefaultPay=='2'">发起方付费</el-radio>
      <el-radio label="2" :disabled="curDefaultPay=='1'">各签署方自付</el-radio> -->
        <template v-if="curDefaultPay != '0' && curDefaultPay != '3'">
          <el-radio
            label="1"
            v-if="curDefaultPay == '1'"
            :disabled="curDefaultPay == '2'"
            >发起方付费</el-radio
          >
          <!-- <el-radio label="2" v-if="curDefaultPay=='2'" :disabled="curDefaultPay=='1'">各签署方自付</el-radio> -->
        </template>
        <template v-else>
          <el-radio label="1">发起方付费</el-radio>
          <!-- <el-radio label="2" >各签署方自付</el-radio> -->
        </template>
      </el-radio-group>
      <span
        style="font-size: 12px; color: #969696; padding-left: 5px"
        v-show="paymentType == 2"
        >（合同签署应付费用总额：<b>¥ {{ sumPrice }}</b
        >）</span
      >
    </el-form-item>
  </el-form>
</template>
<script>
import CustomerDatePicker from "@common/date-picker";
import BaseApi from "@lib/baseApi.js";
// Vue.use(CustomerDatePicker);
export default {
  props: {
    list: {
      type: String,
      default: "add",
    },
  },
  components: { CustomerDatePicker },
  created() {
    this.initSizeDate();
  },
  data() {
    let validateDataStart = (rule, value, callback) => {
      if (value) {
        if (this.sizeForm.endDate && this.dateType == 1) {
          let startTime = new Date(value.replace(/-/g, "/")).getTime();
          let endTime = new Date(
            this.sizeForm.endDate.replace(/-/g, "/")
          ).getTime();
          if (startTime > endTime) {
            callback(new Error("开始时间应该小于结束时间"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback("请选择开始时间");
      }
    };
    let validateDeadlineDate = (rule, value, callback) => {
      if (value) {
        if (this.sizeForm.dateRange && this.dateType == 1) {
          let currentTime = new Date(
            value.slice(0, 4),
            value.slice(5, 7),
            value.slice(8, 10)
          ).getTime();
          let startTime = "";
          if (this.dateType == 1) {
            startTime = new Date(
              this.sizeForm.dateRange.slice(0, 4),
              this.sizeForm.dateRange.slice(5, 7),
              this.sizeForm.dateRange.slice(8, 10)
            ).getTime();
          }
          if (currentTime > startTime && this.dateType == 1) {
            callback(
              "签约截至日期，需要设置在合同有效期开始之前且在当前日期之后"
            );
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback("请选择签约截至日期");
      }
    };
    let dateRangeVaild = (rule, value, callback) => {
      if (this.dateType == 2) {
        value = Number(value);
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入整数"));
        } else if (this.unitForTime == "1") {
          if (value > 31) {
            callback(new Error("年份最多填写30年"));
          }
        } else if (this.unitForTime == "2") {
          if (value > 12) {
            callback(new Error("月份最多填写12个月"));
          }
        } else if (this.unitForTime == "3") {
          if (value > 30) {
            callback(new Error("天数最多填写30日"));
          }
        }
        callback();
      } else if (this.dateType == 1) {
        validateDataStart(rule, value, callback);
      }
    };
    let validateEndDate = (rule, value, callback) => {
      if (this.dateType == 1) {
        if (value) {
          callback();
        } else {
          callback("请选择结束日期");
        }
      } else {
        callback();
      }
    };
    return {
      paymentType: "1", //付费方式:1-发起方，2-各签署方
      curDefaultPay: "0",
      dateType: "1",
      options: [
        {
          value: "1",
          label: "年",
        },
        {
          value: "2",
          label: "月",
        },
        {
          value: "3",
          label: "日",
        },
      ],
      unitForTime: "1",
      sizeForm: {
        name: "",
        dateRange: "",
        signDeadlineDate: "",
        startDate: "",
        endDate: "",
      },
      baseRule: {
        name: [
          { required: true, message: "合同名称不可为空", trigger: "blur" },
          {
            max: 50,
            message: "合同名称为1-50个字符",
            trigger: ["change", "blur"],
          },
        ],
        signDeadlineDate: [
          {
            required: true,
            // validator: validateDeadlineDate,
            trigger: "change",
          },
        ],
        endDate: [{ validator: validateEndDate, trigger: "change" }],
        dateRange: [
          { required: true, validator: dateRangeVaild, trigger: "blur" },
        ],
      },
      disblaedClick: false,
      signDeadlineDateOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
        },
      },
    };
  },
  computed: {
    getSinDataForDealLine() {
      let endDateTimeTmp = this.sizeForm.dateRange;
      return this.handlerOption(endDateTimeTmp, "dealLine");
    },
    getSinDataForEndDate() {
      let endDateTimeTmp = this.sizeForm.dateRange;
      return this.handlerOption(endDateTimeTmp);
    },
  },
  methods: {
    clickDisabledFun() {
      this.$message.warning(
        "签约截至日期，需要设置在合同有效期开始之前且在当前日期之后"
      );
    },
    clickDisabledFunForEndData() {
      this.$message.warning(
        "合同有效期结束时间，需要设置在合同有效期开始时间之后"
      );
    },
    isHaveStartData() {
      if (!this.sizeForm.dateRange && this.dateType == 1) {
        this.$message.warning("请先选择合同有限期的开始时间");
      }
    },
    handlerOption(endDateTimeTmp, flag) {
      let endDateTime = "";
      // console.log(endDateTimeTmp);
      if (endDateTimeTmp && this.dateType == 1) {
        endDateTime = new Date(
          endDateTimeTmp.slice(0, 4),
          endDateTimeTmp.slice(5, 7) - 1,
          endDateTimeTmp.slice(8, 10)
        ).getTime();
      }
      return {
        disabledDate(time) {
          if (endDateTime) {
            if (flag == "dealLine") {
              return (
                time.getTime() > endDateTime ||
                time.getTime() < Date.now() - 1000 * 60 * 60 * 24
              );
            } else {
              return time.getTime() < endDateTime;
            }
          } else {
            return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
          }
        },
      };
    },
    dateTypeChange() {
      this.sizeForm.dateRange = "";
      this.$refs.forms.clearValidate("dateRange");
    },
    handlerSizeForm(origin) {
      let data = {};
      data.name = origin.name;
      data.signDeadlineDate = origin.signDeadlineDate;
      data.validityDateType = this.dateType;
      if (this.dateType == 1) {
        data.startDate = origin.dateRange;
        data.endDate = origin.endDate;
      } else {
        data.validityDate = origin.dateRange;
        data.validityDateUnit = "" + this.unitForTime;
      }
      return data;
    },
    async save() {
      try {
        await this.$refs.forms.validate();
        return Promise.resolve({
          valid: true,
          data: this.handlerSizeForm(this.sizeForm),
        });
      } catch (e) {
        return Promise.resolve({
          valid: false,
          data: null,
        });
      }
    },
    validStart() {
      if (this.sizeForm.dateRange) {
        this.$refs.forms.validateField("dateRange");
      }
    },
    setData(data) {
      this.sizeForm.name = data.name;
      this.sizeForm.signDeadlineDate = data.signDeadlineDate;
      this.dateType = data.validityDateType + "" || "1";
      if (this.dateType == 1) {
        this.sizeForm.dateRange = data.startDate;
        this.sizeForm.endDate = data.endDate;
      } else {
        this.sizeForm.dateRange = data.validityDate;
        this.unitForTime = data.validityDateUnit + "";
      }
    },
    getpayMentType() {
      BaseApi.createRpcToken("/file/contractPayMode", "", "post").then(
        (data) => {
          if (data.datas) {
            this.paymentType =
              data.datas.payMode == 3 ? "1" : data.datas.payMode;
            this.curDefaultPay = data.datas.payMode;
            this.paymentTypeChange(this.paymentType);
          }
        }
      );
    },
    //付费方式:1-发起方，2-各签署方
    paymentTypeChange(data) {
      this.$bus.$emit("paymentTypeValue", this.paymentType);
      return this.paymentType;
    },

    // 获取合同有效期和签约截止日期
    initSizeDate() {
      let ts = new Date().getTime(); // 当天
      let ts1 = ts + 5 * 365 * 24 * 60 * 60 * 1000; // 1年后
      let ts2 = ts + 30 * 24 * 60 * 60 * 1000; // 30天后
      this.sizeForm.dateRange = this.getNowFormatDate(ts);
      this.sizeForm.endDate = this.getNowFormatDate(ts1);
      this.sizeForm.signDeadlineDate = this.getNowFormatDate(ts2);
      console.log(this.getNowFormatDate(ts))
      console.log(this.getNowFormatDate(ts1))
      console.log(this.getNowFormatDate(ts2))
    },

    getNowFormatDate(time) {
      let date = new Date(time),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
      return `${year}-${month}-${strDate}`;
    },
  },
  mounted() {
    this.getpayMentType();
  },
};
</script>
<style lang="scss">
.signForm {
  .el-input__inner:focus {
    border-color: #d81212;
    outline: 0;
  }
  .el-range-editor.is-active {
    border-color: #d81212;
  }
  .nameContract {
    .el-input__inner {
      width: 350px;
    }
  }
  .datePickerStyle {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 160px;
    }
    .chooseWay {
      .validityBox {
        color: #969696;
        .el-input {
          width: 40px;
          margin: 0 10px;
          .el-input__inner {
            border: 0;
            border-radius: 0;
            padding: 0 10px;
            border-bottom: 1px solid #dcdfe6;
          }
        }
        span {
          font-size: 12px;
          color: #969696;
        }
        .timeTypeBox {
          display: inline-block;
          position: relative;
          .el-select {
            .el-input {
              width: 40px;
              text-align: center;
              margin: 0;
              .el-input__inner {
                padding: 0;
                border: 0;
              }
            }
          }
        }
      }
    }
  }

  .formItemDscp {
    font-size: 12px;
    color: #969696;
    margin-left: 20px;
  }
  .el-form-item__label {
    font-size: 12px;
    color: #969696;
  }
}
</style>
